import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function TableChartIcon(props: IconProps) {
    return <Icon {...props} iconKey={"table_chart"}/>
}
